import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import React from 'react';

import healioLogo from '../assets/images/healiospace-logo.svg';
import { useBrandIconStyles } from '../components/header/components/layout/menuStyles/brandIconStyles';

export function BrandIcon({ sx }: SvgIconProps) {
  const theme = useTheme();
  const styles = useBrandIconStyles(theme);

  return (
    <Box className={styles.container} sx={sx}>
      <Box component="img" src={healioLogo} alt="HealioSpace logo" className={styles.logo} />
      <Box className={styles.wordmark}>
        <Typography component="span" className={styles.name}>
          <Box component="span" className={styles.namePrimary}>
            Healio
          </Box>
          <Box component="span" className={styles.nameAccent}>
            Space
          </Box>
        </Typography>
        <Typography component="span" className={styles.tagline}>
          Health coaching, supercharged by AI.
        </Typography>
      </Box>
    </Box>
  );
}
